module.exports = "pegasus/assets/themelp1/ebook/109.png";